<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="widget">
                    <div class="form-elements-sec">
                        <div class="widget-title">
                            <h3>Blog Kategorisi Ekle</h3>
                        </div>
                        <div class="row">

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="title">Kategori Başlığı</label>
                                    <input type="text" v-model="title" class="form-control custom-input">
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="slug">SEF Link</label>
                                    <input type="text" v-model="slug" class="form-control custom-input">
                                </div>
                            </div>

                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for></label>
                                    <button class="btn btn-success pull-right" @click="updateData">Kaydet</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                id: this.$route.params.id,
                title: "",
                api: "blog_categories/"
            };
        },
        mounted() {
            this.getData();
        },
        methods: {
            getData() {
                this.$Progress.start();
                this.axios.get(this.api + this.id + "/edit").then(response => {
                    this.title = response.data.title,
                        this.slug = response.data.slug
                    this.$Progress.finish();
                });
            },
            updateData() {
                this.$Progress.start();
                this.axios
                    .put(this.api + this.id, {
                        title: this.title || '',
                        slug: this.slug || ''
                    })
                    .then(response => {
                        if (response.status == 200) {
                            this.$Progress.finish();
                        }
                    });
            }
        },
        computed: {
            slug: {
                get() {
                    return window.Slug(this.title.toLowerCase())
                },
                set() {
                    let slug = window.Slug(this.title)
                    return slug
                }
            }
        }
    };
</script>

<style scoped>
</style>
